import Vue from "vue"
import Router from "vue-router"
import login from "../pages/login"
import storage from "./storage"
import layout from "../pages/layout"
import notFound from "../pages/404"
import homeRouter from "../pages/home/config/homeRouter"
import sysRouter from "../pages/sys/config/sysRouter"
import eduRouter from "../pages/edu/config/eduRouter"
import finRouter from "../pages/financial/config/financialRouter"
import exchangeRouter from "../pages/exchange/config/exchangeRouter"
import erpRouter from "../pages/erp/config/erpRouter"
import contentRouter from "../pages/content/config/contentRouter"
import reportRouter from "../pages/report/config/reportRouter"
import dataRouter from "../pages/data/config/dataRouter.js"

Vue.use(Router);

const router = new Router({
	mode :'hash',
	routes:[
		{
			path:'/login',
			name:'login',
			component:login
		},
		{
			path:'/',
			component:layout,
			children:[
				{ path: 'admissions/:kind?', component: () => import('../pages/admissions/index.vue') },
				homeRouter,
				sysRouter,
				eduRouter,
				finRouter,
				exchangeRouter,
				erpRouter,
				contentRouter,
				reportRouter,
				dataRouter,
				
			]
		},
		{
			path:'*',
			name:'404',
			redirect:"/",
			component:notFound
		}
	]
});

router.beforeEach((to,form,next)=>{
	if (to.path !== '/login' && to.path !== '/'){
		storage.setRoute(to.path);
	}
	next();
});

// 重复路由warn报错兼容
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
	return originalPush.call(this,location).catch(err => err)
}

export default router
